module.exports = __webpack_public_path__ + "static/media/twitter.56a3544a.png";